import { Skeleton, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

export const InventoryComparisonTableSkeleton = () => {
  return (
    <Table role="presentation">
      <TableHead>
        <TableRow>
          <TableCell width="35%">
            <Skeleton variant="text" sx={{ height: '1.5rem', width: '4rem' }} />
          </TableCell>
          <TableCell>
            <Skeleton variant="text" sx={{ height: '1.5rem', width: '4rem' }} />
          </TableCell>
          <TableCell>
            <Skeleton variant="text" sx={{ height: '1.5rem', width: '4rem' }} />
          </TableCell>
          <TableCell>
            <Skeleton variant="text" sx={{ height: '1.5rem', width: '4rem' }} />
          </TableCell>
          <TableCell width="5%"></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {Array.from(Array(6)).map((_v, index) => (
          <TableRow key={index}>
            <TableCell>
              <Skeleton variant="text" sx={{ height: '1.5rem', width: '8rem' }} />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" sx={{ height: '1.5rem', width: '3rem' }} />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" sx={{ height: '1.5rem', width: '3rem' }} />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" sx={{ height: '1.5rem', width: '6rem' }} />
            </TableCell>
            <TableCell>
              <Skeleton variant="circular" sx={{ height: '1rem', width: '1rem' }} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
